import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { logEvent } from 'helpers/LogReportHelpers';

const Account = props => {
  const [initialized, setInitialized] = useState(false);
  const { getFavorites = () => {}, openAccount = () => {}, setLoading = () => {} } = props;

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      logEvent('onAccountScreenView');
      logEvent('onAccountScreenStart');
    }
    if (getFavorites) getFavorites();
    if (openAccount) openAccount({ utagAccountSource: 'settings' });
    if (setLoading) setLoading(true);
    if (initialized) logEvent('onAccountScreenFinished');
    return () => {
      if (setLoading) setLoading(false);
    };
  }, []);

  return <div />;
};
/* eslint react/require-default-props: 0 */
Account.propTypes = {
  getFavorites: PropTypes.func,
  openAccount: PropTypes.func,
  setLoading: PropTypes.func,
};

export default Account;
